export default __webpack_public_path__ + "static/media/img_post5_1.5a11db27.png";